import { defineStore } from "pinia";
import { reactive, shallowReactive } from "vue";
import { CommonHttp } from "@/models/interfaces/http/common.http.request";
import { rootStore } from "./index";
import { AnalyticsV2ElementType } from "@/models/etc/types";
import { AnalyticsCommentAddOrUpdateRequest, AnalyticsCommentTemplateCreateRequest,
  AnalyticsCommentTemplateDto } from "@/models/interfaces/analytics/analytics-comments";

/**
 * Методы АПИ табличных комментариев аналитики
 */

// API методы по версиям

// v 15.6.0.0
// addOrUpdateComment → PUT api/analytics/comments
// createCommentTemplate → POST api/analytics/comments/templates
// deleteCommentTemplate → DELETE api/analytics/comments/templates/{templateId}
// getCommentTemplates → GET api/analytics/comments/templates

const API_URL = process.env.VUE_APP_API_URL

export type AnalyticsCommentsState = {
  loading: boolean;
  // ignore the request result and don't mutate the model after the request is finished
  stop_request: boolean;
  // новый шаблон табличного комментария.
  comment_template_created: AnalyticsCommentTemplateDto;
};

export const analyticsCommentsStore = defineStore("analyticsCommentsStore", {
  state: () =>
    ({
      loading: false,
      stop_request: false,
      comment_template_created: shallowReactive({} as AnalyticsCommentTemplateDto),
    } as AnalyticsCommentsState),

  actions: {

    // PUT add or update table comment
    async addOrUpdateComment(arg: AnalyticsCommentAddOrUpdateRequest) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined
        await http.put(`analytics/comments`, arg).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          this.loading = false
          return { response_ok: true, data }
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false, data: undefined }
    },

    // GET table comment templates of the segment
    async getCommentTemplates(value?: string, segment?: AnalyticsV2ElementType, count?: number, offset?: number) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined

        await http.get(`analytics/comments/templates?Filter=${value ?? ''}&Segment=${segment ?? 0}&Count=${count}&Offset=${offset}`).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          this.loading = false
          return reactive(data)
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return undefined
    },

    // POST create table comment template
    async createCommentTemplate(arg: AnalyticsCommentTemplateCreateRequest) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined
        await http.post(`analytics/comments/templates`, arg).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          const { data } = response;
          this.comment_template_created = reactive(data);

          this.loading = false
          return { response_ok: true }
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false }
    },

    // DELETE table comment template
    async deleteCommentTemplate(templateId: number) {
      const rootstore = rootStore()
      this.stop_request = false
      const http = new CommonHttp(API_URL, rootstore.globalJWT)
      try {
        this.loading = true
        let response: any = undefined
        await http.delete(`analytics/comments/templates/${templateId}`).then(res => {
          response = res
        }).catch(err => {
          console.log(err);
        });

        // @ts-ignore
        if (response && (response.status === 200 || response.status === 201)) {
          this.loading = false
          return { response_ok: true }
        } else {
          console.log('Error response status:', response?.status);
        }
      } catch (e) {
        console.log(JSON.stringify(e))
        this.loading = false
      }

      this.loading = false
      return { response_ok: false }
    },
  },

  getters: {

    isLoading(state): boolean {
      return state.loading
    },
  },
})
